import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";

import * as Sentry from "@sentry/react";

// Only initialize Sentry in production environment
if (import.meta.env.MODE === "production") {
  Sentry.init({
    dsn: "https://0484f63998664b174345391f65afb2b1@o4509088107134976.ingest.us.sentry.io/4509090366291968",
  });
}

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#667DBE",
            fontFamily: "Poppins",
          },
          components: {
            Card: {
              headerBg: "#1890FF",
              extraColor: "white",
            },
            Menu: {
              // darkItemBg: "#1890FF",
              // darkSubMenuItemBg: "#1890FF",
              // darkGroupTitleColor: "#FFFFFF",
              // darkItemColor: "#FFFFFF",
              itemBg: "#667DBE",
              itemColor: "#FFFFFF",
              groupTitleColor: "#FFFFFF",
              colorSplit: "#F5F5F5",
              groupTitleFontSize: 18,
            },
            Table: {
              headerBg: "#D1DFFF",
              // headerColor: "#FFFFFF",
            },
            Modal: {
              headerBg: "#1890FF",
              titleColor: "#FFFFFF",
            },
            Layout: {
              headerBg: "#667DBE",
              siderBg: "#667DBE",
              bodyBg: "#F0F2F5",
            },
            Tabs: {
              cardBg: "#e6f4ff",
              colorBorder: "#1890FF",
            },
            Radio: {
              buttonBg: "#e6f4ff",
            },
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </StrictMode>,
);
